module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAGZJREFUSEtjZKAxYKSx+Qz0taD50d//+HxUK8cMdhCx6kBqUXxArEZi1Y1agDO6YHE1eIOIlLxDViqiuQWDN5kS63WyfUBzC4h1GbHqBm8+GPUBwUKM7CAiNpmSoo6+dTIpLiNWLQAhKYAZR7E6zAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/img/statistics1.png
// module id = CtRy
// module chunks = 1